  <template>
  <div>
    <communityHeader :router_url='router_url'></communityHeader>

    <!-- 导航 -->
    <div class="header_tag">
      <div class="wrap _height">
        <div class="href_tag _width _height">
          中经视觉社区 &gt;

          <router-link :to="'/communityCircle/'">
            圈子
          </router-link>
          &gt;摄影圈
        </div>
      </div>
    </div>
    <!-- 导航 end-->

    <!-- banner -->
    <div class="banner">
      <div v-show="loading">
        <loading></loading>
      </div>
      <div v-show="!loading"
           class="wrap _height position">
        <img class="bag_img _width fade_image_out"
             :src="headData.cover">
        <div class="user_menu _width">
          <a href="javascript:;"
             class="header_img"><img :src="headData.logo"
                 alt=""></a>
          <div class="user_menu_right">
            <p class="user_name fl _width">{{headData.name}}</p>
            <span class="user_desc _width fl">{{headData.description}}</span>
            <!-- <span class="user_time _width fl"
                  v-if="headData.createTime">{{headData.createTime.substring(0,10)}}</span> -->
            <button class="join"
                    v-show="headData.code==0"
                    @click.stop="join($route.params.id)"
                    v-ripple="'rgba(255, 255, 255, 0.25)'">+ 加入圈子</button>

            <button class="join hover_join"
                    v-show="headData.code==1"
                    @click.stop="canceljoin($route.params.id)"
                    v-ripple="'rgba(255, 255, 255, 0.25)'">
              <p class="_width _height"
                 style="    color: #666;
    background: #fff;transition: all .3s;">已加入</p>
              <p class="_width top"
                 style="    color: #666;
    background: #fff;transition: all .3s;">退出圈子</p>
            </button>

          </div>
        </div>
      </div>

    </div>
    <!-- banner end-->
    <!-- conter -->
    <div class="conter _width">
      <div class="wrap">
        <div class="box_sizing conter_wp"
             style="margin-bottom: 20px;">
          <!-- 本圈作品 -->
          <div class="conter_left box_sizing anmition_show">
            <!-- <p class="title _width">&nbsp;本圈作品</p> -->
            <listConter :circleId="circleId"></listConter>
          </div>
          <!-- 本圈作品 end-->

          <div class="conter_right box_sizing anmition_show">
            <!-- 发表新作品 -->
            <button class="new_update _width"
                    @click="addwork()"
                    v-ripple="'rgba(255, 255, 255, 0.25)'"><span></span>
              <p> +发表新作品</p>
            </button>
            <!-- 圈主头像 -->
            <div class="user_conter _width"
                 style="background: #fff;"
                 v-for="(item,index) in list"
                 :key="index"
                 v-if="item.isAdmin == 1">
              <div>
                <img src="@/assets/image/community/quanzhu.png"
                     alt=""
                     class="active_me_img">
                <div @click="on_ucenter(item.userId)"
                     class="usernanmephoto"
                     style="background: #fff;">
                  <span class="user_header_img"
                        v-if="item.headimg"><img :src="item.headimg"
                         alt=""></span>
                  <span class="user_header_img"
                        v-else><img src="@/assets/image/common/nan.png"
                         alt=""></span>
                  <p>{{item.realname}}</p>
                </div>
                <div @click="on_ucenter(item.userId)"
                     class="ta">TA的主页>></div>
              </div>

            </div>
            <!-- 活跃成员 -->
            <Intelligent :circleId="circleId"></Intelligent>
            <!-- 活跃成员 end-->
          </div>
          <!-- 发表新作品 end-->
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import listConter from '@/components/community/details/list_conter.vue' //左侧
import Intelligent from '@/components/community/details/active_members.vue' //右侧
// 圈主
import {
  circleMember
} from '@/utils/api/active_members.js'
import { Info } from '@/utils/api/login.js'

import {
  circleDetail
} from '@/utils/api/circleDetail.js'
import {
  joinCircle,
  canceljoinCircle
} from '@/utils/api/communityFind.js'
export default {
  data () {
    return {
      loading: true,
      headData: {},
      circleId: "",
      value: '',
      list: [],//圈主信息

    }
  },

  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url
    this.circleId = this.$route.params.id;
    this.getCircleMember();//圈主信息

  },
  mounted () {
    this.getcircleDetail()
  },

  methods: {

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
          // console.log(this.isLogin_user);
        }

      })
    },

    // 点击头像
    on_ucenter (authorId) {
      if (this.isLogin == true) {
        // 如果是自己
        if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
          // let routeData = this.$router.resolve({ path: '/Pcenter?type=0' })
          // window.open(routeData.href, '_blank');
          this.$router.push({ path: '/Pcenter?type=0' })
        } else {
          // 如果不是自己
          this.$router.push({ path: '/Ucenter/' + authorId })
          // let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
          // window.open(routeData.href, '_blank');
        }
      } else {
        this.$router.push({ path: '/Ucenter/' + authorId })

      }
    },
    // 圈主信息
    getCircleMember () {
      let parm = { circleId: this.circleId };
      circleMember(parm).then((res) => {
        if (res.data.code == 200) {
          this.list = res.data.data;
          // console.log(this.list);
        }
      })
    },

    addwork () {
      // 未登录就去登录
      if (this.isLogin == true) {
        if (this.headData.code == 1) {
          this.$router.push({
            name: 'addWork',
            params: {
              id: this.$route.params.id
            }
          })
        } else {
          this.$message({
            message: "请先加入圈子",
            type: 'warning'
          });
        }
      } else {
        sessionStorage.setItem('router_url', this.router_url)//圈子
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

    getcircleDetail () {
      this.loading = true;
      let parmes = {
        circleId: this.$route.params.id
      };
      circleDetail(parmes).then(res => {
        if (res.data.code == 200) {
          this.loading = false;
          this.headData = res.data.data;

          document.title = '圈子详情-' + this.headData.name

        }
      })
    },
    join (id) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let parmes = {
          "circleId": id,
          // "headimg": headimg,
          // "userId": userId
        };
        joinCircle(parmes).then((res) => {
          if (res.data.data.code == 1) {
            this.$notify({
              title: '加入圈子',
              message: '已经加入圈子，无需重复加入！',
              type: 'warning'
            });
          } else {
            this.$notify({
              title: '成功',
              message: '加入圈子成功！',
              type: 'success'
            });
            this.getcircleDetail();
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//圈子
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
    canceljoin (id) {
      if (this.isLogin == true) {
        let userid = sessionStorage.getItem("id");
        canceljoinCircle({
          circleId: id,
          userId: userid
        }).then(res => {
          if (res.data.data.code == 0) {
            this.$notify({
              title: '成功',
              message: '取消加入圈子成功！',
              type: 'success'
            });
            this.getcircleDetail();
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//圈子
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },



  },
  components: {
    communityHeader,
    listConter,
    Intelligent,
    loading
  }
}
</script>
<style scoped>
@import "../../../assets/css/community/circleDetail";

.banner >>> .loading_main {
  min-height: 395px;
}
.join p {
  height: 100%;
  line-height: 0.28rem;
}
.hover_join {
  position: relative;
  overflow: hidden;
}
.top {
  position: absolute;
  top: 0.28rem;
  /* transition: all 0.3s; */
}
.hover_join:hover .top {
  top: 0;
  background-color: #d4011a;
}
.ta {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/community/circle/circleDetail.vue